export default "__VITE_ASSET__DyIu5tJa__"